import { render, staticRenderFns } from "./PriceWorkflowViewFamily.vue?vue&type=template&id=1944de21&scoped=true&"
import script from "./PriceWorkflowViewFamily.vue?vue&type=script&lang=js&"
export * from "./PriceWorkflowViewFamily.vue?vue&type=script&lang=js&"
import style0 from "./PriceWorkflowViewFamily.vue?vue&type=style&index=0&id=1944de21&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1944de21",
  null
  
)

export default component.exports